import Header from './Header'
import Paragraph from './Paragraph'

export { Header, Paragraph }
